module.exports = __webpack_public_path__ + "static/index/img/baikal-406.093ff36a.jpg";